import { z } from 'zod';

/**
 * What earns a discount rule's grant (`03-courses-discounts.md` §Grant issuance).
 *
 * The two are **not** interchangeable, and matrix row 3 is the reason: passing a
 * course's test without finishing its lessons fires the `test_pass` rules and
 * leaves the `course_completion` ones alone. A single "course" source would make
 * the shortcut pay the same as the work.
 */
export const DISCOUNT_SOURCES = ['course_completion', 'test_pass'] as const;

export const DiscountSourceSchema = z.enum(DISCOUNT_SOURCES);

export type DiscountSource = (typeof DISCOUNT_SOURCES)[number];

const SOURCE_SET: ReadonlySet<string> = new Set(DISCOUNT_SOURCES);

export function isDiscountSource(value: string): value is DiscountSource {
  return SOURCE_SET.has(value);
}
